module.exports = __webpack_public_path__ + "static/img/1004_big.e309fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1004_big.png
// module id = p77c
// module chunks = 1